// src/services/EventService.js
import axios from 'axios';
import config from '../config/config'; 
import api from './api';

// Fallback data for when API is unavailable
const FALLBACK_EVENTS = [
  {
    id: 1,
    event_title: "Summer Music Festival",
    event_summary: "Join us for a weekend of great music and fun!",
    event_date: "2023-07-15",
    event_time: "14:00:00",
    event_end_time: "22:00:00",
    location: "Central Park",
    event_graphic: "event1.jpg"
  },
  {
    id: 2,
    event_title: "Tech Conference 2023",
    event_summary: "Learn about the latest tech innovations.",
    event_date: "2023-08-20",
    event_time: "09:00:00",
    event_end_time: "18:00:00",
    location: "Convention Center",
    event_graphic: "event2.jpg"
  }
];

class EventService {
  async fetchEventById(eventId) {
    try {
      
      const response = await axios.get(`${config.BASE_URL}/api/events/${eventId}`);
      
      
      return response.data;
    } catch (error) {
      console.error(`Error fetching event ${eventId}:`, error);
      // Add more detailed error info
      if (error.response) {
        console.error(`Response status: ${error.response.status}`);
        console.error(`Response data:`, error.response.data);
      }
      throw new Error(`Fetch failed with status: ${error.response?.status || 'unknown'}`);
    }
  }

  async createEvent(eventData, token) {
    try {

      // If eventData is already FormData, use it directly
      let formData;
      if (eventData instanceof FormData) {
        formData = eventData;
      } else {
        // Otherwise, create a new FormData and append data
        formData = new FormData();
        Object.keys(eventData).forEach((key) => {
          if (eventData[key] !== undefined && eventData[key] !== null) {
            formData.append(key, eventData[key]);
          }
        });
      }

     
      // Do NOT set Content-Type header for FormData
      const response = await axios.post(`${config.BASE_URL}/api/events`, formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error) {
      console.error('Error creating event:', error);
    
      throw error;
    }
  }

  async fetchEvents(type = 'upcoming') {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/events/${type}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${type} events:`, error);
      throw error;
    }
  }
  
  async fetchEventFootages(eventId) {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/events/${eventId}/footages`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching footages for event ${eventId}:`, error);
      throw error;
    }
  }
}

const eventService = new EventService();

// Export named functions for component imports
export const createEvent = eventService.createEvent.bind(eventService);
export const fetchEventById = eventService.fetchEventById?.bind(eventService);
export const fetchEvents = eventService.fetchEvents?.bind(eventService);
export const fetchEventFootages = eventService.fetchEventFootages?.bind(eventService);
export const getLatestEvents = async () => {
  try {
    const response = await api.get('/api/events/latest');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching latest events:', error);
    // Return fallback data for 502 errors or other failures
    return FALLBACK_EVENTS;
  }
};

export const getUpcomingEvents = async () => {
  try {
    const response = await api.get('/api/events/upcoming');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching upcoming events:', error);
    return FALLBACK_EVENTS;
  }
};

// Default export
export default eventService;
